import { render, staticRenderFns } from "./NeuerTerminModal.vue?vue&type=template&id=5ed471ec"
import script from "./NeuerTerminModal.vue?vue&type=script&lang=js"
export * from "./NeuerTerminModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports